export default {
  copy: 'In die Zwischenablage kopieren',
};
